import React from 'react';

import { Segment, OasEstimator as Estimator } from 'components';

export default () => (
  <Segment style={{ minHeight: '100%' }}>
    <Estimator />
  </Segment>
);
